import { render, staticRenderFns } from "./VxSelect.vue?vue&type=template&id=5c141044&scoped=true"
import script from "./VxSelect.vue?vue&type=script&lang=js"
export * from "./VxSelect.vue?vue&type=script&lang=js"
import style0 from "./VxSelect.vue?vue&type=style&index=0&id=5c141044&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c141044",
  null
  
)

export default component.exports